import React from "react";
import { formatDate } from "../../utils/formatDate";
import Button from "../Button";
import icnDownload from "../../assets/icons/icn-download.png";
import icnCheckGreen from "../../assets/icons/icn-check-green.svg";
import Icon from "../Icon";
import usePrescriptionDownload from "../../hooks/usePrescriptionDownload";

import "./styles.css";

function Card({ prescription }) {
  const { token, date, signed, practitionerName } = prescription;
  const { pdfAccess, buttonProps } = usePrescriptionDownload(prescription);

  return (
    <>
      <td className="column-table">
        <div className="inline-text">
          <span>Token</span>
          <span>{token}</span>
        </div>

        <div className="inline-text">
          <span>Assinada</span>
          {signed ? (
            <Icon icon={icnCheckGreen} size={24} alt="icone de assinatura" />
          ) : (
            <></>
          )}
        </div>

        <div className="inline-text">
          <span>Data</span>
          <span>{formatDate(date)}</span>
        </div>

        <div className="inline-text">
          <span>Médico</span>
          <span>{practitionerName}</span>
        </div>

        <Button {...buttonProps} icon={icnDownload}>
          {pdfAccess ? "Download" : "PDF indisponível"}
        </Button>
      </td>
    </>
  );
}

export default Card;
